import { gql } from '@apollo/client';

const SUGGEST_STRIP_COMMENT = gql`
  mutation suggestStripComment($input: SuggestStripCommentInput!) {
    suggestStripComment(input: $input) {
      isSuccess
      message
      comment
    }
  }
`;

export default SUGGEST_STRIP_COMMENT;
